export type MapMarkerPosition = {
  lat: number
  lng: number
}

export type MamorioPositionGroup = {
  position: MapMarkerPosition
  positionKey: string
  mamorios: IMamorio[]
}

export const getMapMarkerPositionKey = (position: MapMarkerPosition): string => (
  `${position.lat}:${position.lng}`
)

export const groupMamoriosByPosition = (
  mamorios: IMamorio[],
  getPosition: (mamorio: IMamorio) => MapMarkerPosition | null | undefined,
): MamorioPositionGroup[] => {
  const groupsByPosition = new Map<string, MamorioPositionGroup>()

  mamorios.forEach((mamorio) => {
    const position = getPosition(mamorio)
    if (!position) return

    const positionKey = getMapMarkerPositionKey(position)
    const existingGroup = groupsByPosition.get(positionKey)

    if (existingGroup) {
      existingGroup.mamorios.push(mamorio)
      return
    }

    groupsByPosition.set(positionKey, {
      position,
      positionKey,
      mamorios: [mamorio],
    })
  })

  return Array.from(groupsByPosition.values())
}

export const calculateMamorioClusterIcon = (
  markers: (google.maps.Marker & { mamorioCount?: number })[],
  numStyles: number,
) => {
  const count = markers.reduce((total, marker) => total + (marker.mamorioCount ?? 1), 0)
  const index = Math.min(String(count).length, numStyles)

  return {
    text: String(count),
    index,
    title: '',
  }
}
